'use client';

import { useLanguageSwitcher } from '@/components/LanguageSwitcher/hooks';
import NavigationLink from "@/components/NavigationLink";
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { cn } from '@/lib/utils';

const baseClassName =
  'border-none text-background text-xl font-semibold py-4 [&_svg]:text-current [&_svg]:size-6 hover:[&_a]:text-secondary [&_a]:transition-colors';

export default function LanguageSwitcher({ labels = {}, languages = [], className }) {
  const { language } = labels;
  const { locale, getLink } = useLanguageSwitcher();

  if (languages.length < 2) return <></>;

  const activeLabel = languages.find(({ code }) => code === locale)?.label;

  return (
    <AccordionItem
      value='language-switcher-accordion'
      className={cn(baseClassName, 'h-fit data-[state=open]:bg-destructive-foreground transition-colors', className)}
    >
      <AccordionTrigger className={cn(baseClassName, 'px-4 py-0 [&_svg]:hidden')}>
        <p className='text-lg xs:text-xl'>
          {language}: {activeLabel}
        </p>
      </AccordionTrigger>
      <AccordionContent asChild className='pb-0 mt-4 !px-0'>
        <div className='flex flex-col'>
          {languages.map((language, index) => (
            <a
              href={getLink(language.code)}
              className='px-4 py-2 text-lg font-normal cursor-pointer hover:bg-black/5'
              key={index}
            >
              {language.label}
            </a>
          ))}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
